import { Entity } from "./entity";
import { Agency } from "./agency";
import { Principal } from "./principal";
import { WhatsNew } from "./whatsNew";

export class PrincipalWhatsNew extends Entity {
    PrincipalId: number;
    WhatsNewId: number;
    Hide?: boolean;

    WhatsNew: WhatsNew;
    Principal: Principal | null;

    static newItem(principalId: number): PrincipalWhatsNew {
        let item = new PrincipalWhatsNew();
        item.PrincipalId = principalId;
        item.Id = 0;
        return item;
    }
}

export class PrincipalWhatsNewSearchModel extends Entity {
    PrincipalId: number;
}